import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { extractValueFromParams, isNullOrEmpty, getRouteSegment, getParentRouteWithDataProperty } from '@awp/core/utils';

interface PageDetails {
  pageUrl: string;
  parentUrl: string;
}

interface ErrorPage {
  name: string;
  pageDetails: PageDetails;
}

@Injectable({
  providedIn: 'root',
})
export class CheckErrorPageExistsGuard implements CanActivate {

  constructor(
    private router: Router,
    private contentProvider: ContentProvider) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | UrlTree {
    const pageId = route.paramMap.get('pageId');
    const themeId = extractValueFromParams(route, 'themeId');
    const purchaseSegment = getRouteSegment(getParentRouteWithDataProperty(route, 'isPurchasePath'));

    return this.contentProvider.fetchRoot()
      .pipe(
        map(p => {
          const errorPages: ErrorPage[] = p != null && p._embedded != null && p._embedded.errorPages != null ? p._embedded.errorPages.errors : null;

          if (errorPages != null) {

            const errorPage = errorPages.find(i => i.pageDetails != null && i.pageDetails.pageUrl === pageId
              && (
                (isNullOrEmpty(themeId) && isNullOrEmpty(i.pageDetails.parentUrl))
                || (i.pageDetails.parentUrl === ':themeId' && !isNullOrEmpty(themeId) && purchaseSegment == null)
                || (i.pageDetails.parentUrl === `:themeId\\${purchaseSegment}`)
              )
            );

            if (errorPage != null) {
              return true;
            }
          }

          return isNullOrEmpty(themeId)
            ? this.router.createUrlTree(['/', 'page', 'not-found'])
            : this.router.createUrlTree(['/', themeId, 'page', 'not-found']);
        })
      );
  }

}
